import React from 'react';
import { Box } from '@honda-canada/design-system-react';
import themeStyles from './SpeedometerCharts.styles';
import getChartColor from '../utils';
var SpeedometerChartUi = function (_a) {
    var _b = _a.newValue, newValue = _b === void 0 ? 99 : _b, color = _a.color;
    var dimensions = 120;
    var strokeWidth = 14;
    var halfDimensions = dimensions * 0.5;
    var radius = halfDimensions - strokeWidth * 0.5;
    var circumference = 2 * Math.PI * radius;
    var strokeVal = (newValue * circumference) / 100;
    var dashVal = "".concat(strokeVal, " ").concat(circumference);
    var trackStyle = { strokeWidth: strokeWidth / 2 };
    var indicatorStyle = { strokeWidth: strokeWidth, strokeDasharray: dashVal };
    var rotateVal = "rotate(-90 ".concat(halfDimensions, ",").concat(halfDimensions, ")");
    var Container = themeStyles.apply('div', 'Container');
    var SVG = themeStyles.apply('svg', 'SVG');
    var ChartTrack = themeStyles.apply('circle', 'ChartTrack');
    var ChartTrackIndicator = themeStyles.apply('circle', 'ChartTrackIndicator');
    var ChartValueContainer = themeStyles.apply(Box, 'ChartValueContainer');
    var ChartValueSymbol = themeStyles.apply(Box, 'ChartValueSymbol');
    var ChartValue = themeStyles.apply('span', 'ChartValue');
    return (React.createElement(Container, null,
        React.createElement(SVG, { "data-testid": "speedometer-chart", width: dimensions, height: dimensions, color: getChartColor(color) },
            React.createElement(ChartTrack, { r: radius, cx: halfDimensions, cy: halfDimensions, transform: rotateVal, style: trackStyle, className: "chart-track" }),
            React.createElement(ChartTrackIndicator, { r: radius, cx: halfDimensions, cy: halfDimensions, transform: rotateVal, style: indicatorStyle, className: "chart-indicator" })),
        React.createElement(ChartValueContainer, null,
            React.createElement(ChartValue, { "data-testid": "chart-value", className: "chart-value" }, newValue.toString()),
            React.createElement(ChartValueSymbol, null, "%"))));
};
export default SpeedometerChartUi;
